import { ExternalLink, Github } from 'lucide-react'
import { useI18n } from '../i18n'

const repositories = [
  {
    key: 'agent' as const,
    href: 'https://github.com/jzjzzzzzzz/agent-me',
    name: 'agent-me',
  },
  {
    key: 'human' as const,
    href: 'https://github.com/jzjzzzzzzz/human-api',
    name: 'human-api',
  },
]

export function OpenSourceLinks({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n()

  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2" aria-label={t('openSource.title')}>
        {repositories.map((repository) => (
          <a
            key={repository.name}
            href={repository.href}
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-1 font-semibold text-moss underline-offset-4 hover:underline"
          >
            <Github size={12} aria-hidden="true" /> {repository.name}
          </a>
        ))}
      </div>
    )
  }

  return (
    <section className="mt-12 border-t border-ink/10 pt-10" aria-labelledby="open-source-heading">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-moss">{t('openSource.eyebrow')}</p>
      <div className="mt-3 grid gap-6 lg:grid-cols-[.7fr_1.3fr]">
        <div>
          <h2 id="open-source-heading" className="font-serif text-4xl tracking-[-0.035em]">{t('openSource.title')}</h2>
          <p className="mt-4 max-w-lg text-sm leading-6 text-ink/55">{t('openSource.copy')}</p>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          {repositories.map((repository) => (
            <a
              key={repository.name}
              href={repository.href}
              target="_blank"
              rel="noreferrer noopener"
              className="group rounded-lg border border-ink/10 bg-white p-5 transition hover:-translate-y-0.5 hover:border-moss/45"
            >
              <span className="flex items-center justify-between">
                <Github size={18} aria-hidden="true" />
                <ExternalLink size={14} className="text-ink/35 transition group-hover:text-moss" aria-hidden="true" />
              </span>
              <strong className="mt-8 block font-mono text-sm">{repository.name}</strong>
              <span className="mt-2 block text-sm leading-6 text-ink/55">
                {t(repository.key === 'agent' ? 'openSource.agentCopy' : 'openSource.humanCopy')}
              </span>
              <span className="mt-5 block text-xs font-bold text-moss">{t('openSource.view')}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
